import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import { useSelector } from 'hooks/useSelector';
import { selectRptReportIsLoading } from 'store/remote/selectors';
import { ActivityIndicator } from 'components/BlockingLoader/ActivityIndicator';
import { theme } from 'lib/theme';

export const ReportingGridLoader: React.FC<{ reportKey: string }> = ({
  reportKey,
}) => {
  const reportIsLoading = useSelector((state) =>
    selectRptReportIsLoading(state, reportKey),
  );
  if (!reportIsLoading) {
    return null;
  }
  return (
    <View
      style={[
        StyleSheet.absoluteFill,
        {
          zIndex: 1,
          alignItems: 'center',
          backgroundColor: `${theme.colors.background50}`,
          justifyContent: 'center',
        },
      ]}
    >
      <ActivityIndicator size={60} />
    </View>
  );
};
